import React, { useState, useEffect } from 'react'

import '../../sytles/button.scss'

const BingoSquareB = () => {
    const [clicked, setClicked ] = useState(window.localStorage.getItem('toggleBtnHandler2') === 'true')

    useEffect(() => {
      window.localStorage.setItem('toggleBtnHandler2', clicked)
    }, [clicked]);

    const toggleBtnHandler = () => {
      setClicked(!clicked)
    }  

     {
      const styles = ['button']
      let text = 'Clue over 20m!'
      let bodyEl = document.body
      bodyEl.style.background = '#1f1f1f'
      
      if (clicked) {
        styles.push('clicked')
        text = 'Clue over 20m!';
        bodyEl.style.background = '#EEE'
      } 
      return (
     <div className={`main ${clicked ? "toggleBtnHandler": ''}`}>
        <div className={BingoSquareB}>
            <button className={styles.join(' ')} onClick={toggleBtnHandler}>{text}</button>
        </div>
     </div>
      )
    }
  }

  export default BingoSquareB